import React from 'react';

function CallWhite(props: object) {
  return (
    <svg
      width="59"
      height="60"
      viewBox="0 0 59 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_dddd_1788_52782)">
        <path
          d="M44 34.3402V40.3402C44.0023 40.8972 43.8882 41.4485 43.665 41.9589C43.4419 42.4692 43.1146 42.9274 42.7042 43.3039C42.2937 43.6805 41.8091 43.9672 41.2815 44.1456C40.7538 44.3241 40.1947 44.3903 39.64 44.3402C33.4857 43.6715 27.574 41.5685 22.38 38.2002C17.5477 35.1295 13.4507 31.0325 10.38 26.2002C6.99996 20.9826 4.89649 15.0422 4.24 8.86019C4.19002 8.30713 4.25575 7.74971 4.433 7.22344C4.61025 6.69717 4.89514 6.21357 5.26953 5.80344C5.64392 5.3933 6.09961 5.06561 6.60758 4.84124C7.11555 4.61686 7.66468 4.50072 8.22 4.50019H14.22C15.1906 4.49064 16.1316 4.83435 16.8675 5.46726C17.6035 6.10017 18.0842 6.97909 18.22 7.94019C18.4732 9.86033 18.9429 11.7456 19.62 13.5602C19.8891 14.276 19.9473 15.054 19.7878 15.802C19.6283 16.5499 19.2577 17.2364 18.72 17.7802L16.18 20.3202C19.0271 25.3273 23.1729 29.4731 28.18 32.3202L30.72 29.7802C31.2638 29.2425 31.9503 28.8719 32.6982 28.7124C33.4462 28.5529 34.2242 28.6111 34.94 28.8802C36.7545 29.5573 38.6399 30.0269 40.56 30.2802C41.5315 30.4173 42.4188 30.9066 43.0531 31.6552C43.6873 32.4038 44.0243 33.3593 44 34.3402Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddd_1788_52782"
          x="-1"
          y="-0.5"
          width="63"
          height="63"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1" dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1788_52782"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1788_52782"
            result="effect2_dropShadow_1788_52782"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="5" dy="5" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_1788_52782"
            result="effect3_dropShadow_1788_52782"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="9" dy="9" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_1788_52782"
            result="effect4_dropShadow_1788_52782"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect4_dropShadow_1788_52782"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default CallWhite;
